import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import DataService from "../../../../../Service";
import Typography from "@material-ui/core/Typography";
import Popover from "@material-ui/core/Popover";
import { makeStyles, Button } from "@material-ui/core";
import ManageCoachRateCard from "./manage_coach_rate_card";
import InternalExternalCoaching from "./InternalExternalCoaching";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { TooltipWrapper } from "../../../../../Common/Utils/common_utils";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: "5%",
    paddingTop: "0px",
    "& .MuiTouchRipple-root": {
      position: "relative",
    },
  },
  tableWrapper: {
    padding: "5%",
  },
  title: {
    fontSize: theme.spacing(3),
    fontWeight: 700,
    padding: theme.spacing(2),
  },
  subTitle: {
    fontSize: theme.spacing(2),
    fontWeight: 500,
  },
  paper: {
    boxShadow:
      "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
    minHeight: "200px",
  },
  detailWrap: {
    padding: "20px",
  },
  root: {
    borderBottom: "none !important",
  },
  actions: {
    borderBottom: "none !important",
    color: "green",
  },
  buttonShadow: {
    textTransform: "inherit",
    fontWeight: "normal",

    "&:hover": {
      "background-color": "none !important",
    },
  },
}));

export default function CoachRateCard(props) {
  const rateCard = useSelector((state) => state.commonReducer)?.accessPermission
    ?.assignmentDetail?.others?.rateCard;
  const location = useLocation();
  const globaluserData = useSelector((state) => state.commonReducer);

  const role = globaluserData?.role || "";
  const classes = useStyles();
  const [currentSelection, setCurrentSelection] = useState({});
  const [CoachinRates, setModuleSetups] = useState([]);
  const [action, setAction] = useState(null);
  const [modules, setModules] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(100);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [openPopover, setPopover] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [refresh, setRefresh] = useState(false);

  const tableOptions = {
    search: true,
    rowStyle: (rowData) => ({
      backgroundColor:
        currentSelection &&
        currentSelection.tableData &&
        currentSelection.tableData.id === rowData.tableData.id
          ? "#f8bbd0"
          : "#FFF",
    }),
  };
  const columns = [
    { title: "Region name", field: "region_name" },
    { title: "Currency", field: "currency" },
  ];

  const CoachinRate = () => {
    const params = {
      organisation_id: props.organisationId,
      page: page + 1 || 1,
      count_per_page: pageSize || 20,
    };
    DataService.getDirectData(
      `/rate_cards/listing_available_regions`,
      params
    ).then((res) => {
      setTotalCount(res["total_count"]);
      if (res.available_regions && res.available_regions.length > 0) {
        let CoachinRates = res["available_regions"];
        setModuleSetups(CoachinRates);
      }
      setLoading(false);
    });
  };

  const handleClose = (data, id) => {
    let moduleList = [];
    if (action === "create" && data && data.id) {
      moduleList = [data].concat(modules);
      setModules(moduleList);
    } else if (data && data.id) {
      moduleList = modules.map((base) => {
        if (base.id === data.id) {
          return data;
        }
        return base;
      });
      setModules(moduleList);
    } else if (!data && id) {
      moduleList = modules.filter((base) => base.id !== id);
      setModules(moduleList);
    }
    setAction(null);
    setCurrentSelection({});
  };
  useEffect(() => {
    setLoading(true);
    CoachinRate();
    // setRefresh(!refresh)
  }, [page, pageSize, props.organisationId, refresh]);

  useEffect(() => {
    const currentSelectionData =
      CoachinRates?.length &&
      CoachinRates?.find((item) => item?.id === currentSelection?.id);
    setCurrentSelection(currentSelectionData);
  }, [CoachinRates]);

  return (
    <div className={classes.wrapper}>
      <Typography
        style={{ paddingLeft: "15px", fontWeight: "bold", paddingTop: 20 }}
        variant='h1'
        color='primary'
      >
        Coaching rate card
      </Typography>
      <Typography
        style={{ padding: "15px" }}
        variant='subtitle1'
        color='secondary'
      >
        Available regions
      </Typography>
      <div id='coach-rate-card-border'>
        <MaterialTable
          title=''
          classes={{
            root: classes.root,
            actions: classes.actions,
          }}
          options={{
            rowStyle: {
              borderBottom: "none",
            },
            cellStyle: {
              borderBottom: "none",
            },

            pageSizeOptions: [20, 50, 75, 100],
            headerStyle: {
              position: "sticky",
              top: "0",
              marginTop: "10px",
              borderBottom: "none",
            },
            maxBodyHeight: "600px",
            actionsColumnIndex: -1,
            search: false,
            actionsCellStyle: {
              borderBottom: "none",
            },
            pageSize: pageSize,
            total: totalCount,
            emptyRowsWhenPaging: false,
          }}
          // options={tableOptions}
          style={{ width: "55%" }}
          columns={columns}
          data={CoachinRates}
          totalCount={totalCount}
          page={page}
          onChangePage={(page) => {
            setPage(page);
          }}
          onChangeRowsPerPage={(pageSize) => {
            setPageSize(pageSize);
          }}
          onSearchChange={(search) => {
            setSearchText(search);
          }}
          localization={{
            header: {
              actions: "",
            },
          }}
          actions={[
            !rateCard?.disableEditIcon && {
              icon: () => <EditIcon fontSize='small' />,
              iconProps: { style: { fontSize: "14px", color: "green" } },
              tooltip: <TooltipWrapper text='Edit' />,
              onClick: (event, rowData) => {
                setAction("edit");
                setCurrentSelection(rowData);
              },
            },

            {
              icon: () => <VisibilityIcon fontSize='small' />,
              iconProps: { style: { fontSize: "14px", color: "green" } },
              tooltip: <TooltipWrapper text='View' />,
              onClick: (event, rowData) => {
                setCurrentSelection(rowData);
              },
            },

            // {
            //   icon: () => <DeleteIcon fontSize="small" />,
            //   tooltip: "Delete",
            //   onClick: (event, rowData) => {
            //     setCurrentSelection(rowData);
            //     setAction("delete");
            //   },
            // },
            {
              icon: () =>
                role !== "admin" ? (
                  ""
                ) : (
                  <Button
                    style={{ fontSize: "14px" }}
                    disableElevation
                    className={classes.buttonShadow}
                    variant='contained'
                    color='secondary'
                  >
                    {role !== "admin" ? "" : " + New region"}
                  </Button>
                ),
              isFreeAction: true,
              onClick: (event) => {
                setAction("create");
                setCurrentSelection({});
              },
            },
          ]}
        />
      </div>
      {openPopover === "view_more" && (
        <Popover
          anchorOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
          open={openPopover === "view_more"}
          anchorEl={anchorEl}
          onBackdropClick={() => setPopover(null)}
        >
          <div>
            <Typography
              style={{ padding: "5px 0 5px 15px" }}
              variant='subtitle2'
              color='secondary'
            >
              {currentSelection.module_name}
            </Typography>
          </div>
        </Popover>
      )}
      {action && (
        <ManageCoachRateCard
          action={action}
          CoachinRate={CoachinRate}
          organisationId={props.organisationId}
          moduleId={currentSelection?.id}
          data={currentSelection}
          handleClose={handleClose}
        />
      )}
      <InternalExternalCoaching
        regionName={currentSelection?.region_name}
        externalData={currentSelection?.external_rate_cards}
        internalData={currentSelection?.internal_rate_cards}
        regionId={currentSelection?.id}
        organisationId={props.organisationId}
        setRefresh={setRefresh}
        refresh={refresh}
      />
    </div>
  );
}
